/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'vrf-context';

export const vrfContextModalBreadcrumbTitle = `${prefix}.vrfContextModalBreadcrumbTitle`;
export const routingOptionsLabel = `${prefix}.routingOptionsLabel`;
export const bgpPeerLabel = `${prefix}.bgpPeerLabel`;

export const ENGLISH = {
    [vrfContextModalBreadcrumbTitle]: 'Vrf Context',
    [routingOptionsLabel]: 'Routing Options',
    [bgpPeerLabel]: 'Peer ({0})',
};
